// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/membership_service.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AcceptVisionInviteRequestSchema, AcceptVisionInviteResponseSchema } from "./accept_vision_invite_pb";
import { file_vision_membership_v1_accept_vision_invite } from "./accept_vision_invite_pb";
import type { ChangeVisionMemberRoleRequestSchema, ChangeVisionMemberRoleResponseSchema } from "./change_vision_member_role_pb";
import { file_vision_membership_v1_change_vision_member_role } from "./change_vision_member_role_pb";
import type { CreateVisionInviteRequestSchema, CreateVisionInviteResponseSchema } from "./create_vision_invite_pb";
import { file_vision_membership_v1_create_vision_invite } from "./create_vision_invite_pb";
import type { GetVisionInviteByTokenRequestSchema, GetVisionInviteByTokenResponseSchema } from "./get_vision_invite_by_token_pb";
import { file_vision_membership_v1_get_vision_invite_by_token } from "./get_vision_invite_by_token_pb";
import type { LeaveVisionProjectRequestSchema, LeaveVisionProjectResponseSchema } from "./leave_vision_project_pb";
import { file_vision_membership_v1_leave_vision_project } from "./leave_vision_project_pb";
import type { ListVisionInvitesRequestSchema, ListVisionInvitesResponseSchema } from "./list_vision_invites_pb";
import { file_vision_membership_v1_list_vision_invites } from "./list_vision_invites_pb";
import type { ListVisionMembersRequestSchema, ListVisionMembersResponseSchema } from "./list_vision_members_pb";
import { file_vision_membership_v1_list_vision_members } from "./list_vision_members_pb";
import type { RemoveVisionMemberRequestSchema, RemoveVisionMemberResponseSchema } from "./remove_vision_member_pb";
import { file_vision_membership_v1_remove_vision_member } from "./remove_vision_member_pb";
import type { ResendVisionInviteRequestSchema, ResendVisionInviteResponseSchema } from "./resend_vision_invite_pb";
import { file_vision_membership_v1_resend_vision_invite } from "./resend_vision_invite_pb";
import type { RevokeVisionInviteRequestSchema, RevokeVisionInviteResponseSchema } from "./revoke_vision_invite_pb";
import { file_vision_membership_v1_revoke_vision_invite } from "./revoke_vision_invite_pb";
import type { TransferVisionProjectOwnershipRequestSchema, TransferVisionProjectOwnershipResponseSchema } from "./transfer_vision_project_ownership_pb";
import { file_vision_membership_v1_transfer_vision_project_ownership } from "./transfer_vision_project_ownership_pb";

/**
 * Describes the file vision/membership/v1/membership_service.proto.
 */
export const file_vision_membership_v1_membership_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_vision_membership_v1_accept_vision_invite, file_vision_membership_v1_change_vision_member_role, file_vision_membership_v1_create_vision_invite, file_vision_membership_v1_get_vision_invite_by_token, file_vision_membership_v1_leave_vision_project, file_vision_membership_v1_list_vision_invites, file_vision_membership_v1_list_vision_members, file_vision_membership_v1_remove_vision_member, file_vision_membership_v1_resend_vision_invite, file_vision_membership_v1_revoke_vision_invite, file_vision_membership_v1_transfer_vision_project_ownership]);

/**
 * @generated from service protos.vision.membership.v1.VisionMembership
 */
export const VisionMembership: GenService<{
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.GetVisionInviteByToken
   */
  getVisionInviteByToken: {
    methodKind: "unary";
    input: typeof GetVisionInviteByTokenRequestSchema;
    output: typeof GetVisionInviteByTokenResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.AcceptVisionInvite
   */
  acceptVisionInvite: {
    methodKind: "unary";
    input: typeof AcceptVisionInviteRequestSchema;
    output: typeof AcceptVisionInviteResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.CreateVisionInvite
   */
  createVisionInvite: {
    methodKind: "unary";
    input: typeof CreateVisionInviteRequestSchema;
    output: typeof CreateVisionInviteResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.ListVisionInvites
   */
  listVisionInvites: {
    methodKind: "unary";
    input: typeof ListVisionInvitesRequestSchema;
    output: typeof ListVisionInvitesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.RevokeVisionInvite
   */
  revokeVisionInvite: {
    methodKind: "unary";
    input: typeof RevokeVisionInviteRequestSchema;
    output: typeof RevokeVisionInviteResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.ResendVisionInvite
   */
  resendVisionInvite: {
    methodKind: "unary";
    input: typeof ResendVisionInviteRequestSchema;
    output: typeof ResendVisionInviteResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.ListVisionMembers
   */
  listVisionMembers: {
    methodKind: "unary";
    input: typeof ListVisionMembersRequestSchema;
    output: typeof ListVisionMembersResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.ChangeVisionMemberRole
   */
  changeVisionMemberRole: {
    methodKind: "unary";
    input: typeof ChangeVisionMemberRoleRequestSchema;
    output: typeof ChangeVisionMemberRoleResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.RemoveVisionMember
   */
  removeVisionMember: {
    methodKind: "unary";
    input: typeof RemoveVisionMemberRequestSchema;
    output: typeof RemoveVisionMemberResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.LeaveVisionProject
   */
  leaveVisionProject: {
    methodKind: "unary";
    input: typeof LeaveVisionProjectRequestSchema;
    output: typeof LeaveVisionProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.membership.v1.VisionMembership.TransferVisionProjectOwnership
   */
  transferVisionProjectOwnership: {
    methodKind: "unary";
    input: typeof TransferVisionProjectOwnershipRequestSchema;
    output: typeof TransferVisionProjectOwnershipResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_membership_v1_membership_service, 0);

